import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getPatientPartners, getFilterableTreatments } from '../../../api/patient_partners';
import { createConversation } from '../../../api/conversations';
import { Link } from 'react-router-dom';

import PartnersGalleryModal from '../../ui_kit/modals/partners_gallery_modal';
import Pagination from '../../system/pagination';
import PatientPartnerColumnForGallery from '../patient_partner_column_for_gallery';
import CustomCtaFooter from '../custom_cta_footer';
import LoadingScreen from '../../system/loading_screen';
import IconButtonSvg from '../../ui_kit/utilities/icon_button_svg';
import DropdownInput from '../../ui_kit/utilities/dropdown_input';
import ScrollTo from '../../system/scroll_to';
import Context from '../../../utils/context';
import HeaderLeftTextRight from '../hero_sections/header_left_text_right';

import './partners.css';

export default function Partners() {
  const filterableAges = [
    {
      value: '18-24',
      low: 18,
      high: 24,
    },
    {
      value: '25-34',
      low: 25,
      high: 34,
    },
    {
      value: '35-44',
      low: 35,
      high: 44,
    },
    {
      value: '45-54',
      low: 45,
      high: 54,
    },
    {
      value: '55-64',
      low: 55,
      high: 64,
    },
    {
      value: '65-74',
      low: 65,
      high: 74,
    },
    {
      value: '75+',
      low: 75,
      high: 200,
    },
  ];
  const [isLoading, setIsLoading] = useState(true);
  const [filterableTreatments, setFilterableTreatments] = useState([]);
  const [patientPartners, setPatientPartners] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [selectedPartnerForModal, setSelectedPartnerForModal] = useState(null);
  const [chosenProcedures, setChosenProcedures] = useState(
    new URLSearchParams(window.location.search).get('procedures') != null
      ? new URLSearchParams(window.location.search)
          .get('procedures')
          .split(',')
          .map((procedure) => ({ value: procedure }))
      : []
  );
  const [chosenAges, setChosenAges] = useState(
    new URLSearchParams(window.location.search).get('age') != null
      ? new URLSearchParams(window.location.search)
          .get('age')
          .split(',')
          .map((age) => filterableAges.filter((a) => a.value === age)[0])
          .filter((age) => age !== undefined)
      : []
  );
  const [chosenGender, setChosenGender] = useState(
    new URLSearchParams(window.location.search).get('gender') != null
      ? new URLSearchParams(window.location.search)
          .get('gender')
          .split(',')
          .map((gender) => ({ value: gender }))
      : []
  );

  const context = useContext(Context);
  const isLoggedIn = context.auth.isLoggedIn();
  const isMobile = context.viewport.getIsMobile();

  let history = useHistory();

  const handlePageChange = (page) => {
    setCurrentPage(page);
    ScrollTo('.gallery-sec', 200);
  };

  const clearFilters = () => {
    setChosenProcedures([]);
    setChosenAges([]);
    setChosenGender([]);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);

    let searchParams = new URLSearchParams();

    if (chosenAges.length > 0) searchParams.append('age', chosenAges.map((age) => age.value).join(','));
    if (chosenProcedures.length > 0) searchParams.append('procedures', chosenProcedures.map((p) => p.value).join(','));
    if (chosenGender.length > 0) searchParams.append('gender', chosenGender.map((g) => g.value).join(','));
    history.push('?' + searchParams.toString());
  }, [chosenProcedures, chosenAges, chosenGender]);

  useEffect(() => {
    setIsLoading(true);
    getFilterableTreatments((data) => {
      setFilterableTreatments(data);
    });
    const filters = {
      age: chosenAges.length > 0 ? chosenAges.map((age) => age.value).join(',') : null,
      gender: chosenGender.length > 0 ? chosenGender.map((g) => g.value).join(',') : null,
      procedures: chosenProcedures.length > 0 ? chosenProcedures.map((p) => p.value).join(',') : null,
    };
    getPatientPartners(
      currentPage || 1,
      (data) => {
        setPatientPartners(data.users || data);
        if (data.meta && data.meta.pagination) {
          setPagination(data.meta.pagination);
        }
        setIsLoading(false);
      },
      filters
    );
  }, [chosenAges, chosenGender, chosenProcedures, currentPage]);

  const [makeSticky, setMakeSticky] = useState(false);
  function stickyScroll() {
    if (document.querySelector('.gallery-sec').getBoundingClientRect().y < 500) {
      setMakeSticky(true);
    } else {
      setMakeSticky(false);
      setShowFilters(false);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', stickyScroll);
    return () => window.removeEventListener('scroll', stickyScroll);
  }, []);

  const partnersForGalleryToShowInRows = [];
  for (var i = 0; i < patientPartners.length; i += 3) {
    partnersForGalleryToShowInRows.push(patientPartners.slice(i, i + 3));
  }

  const generateActionContent = (partner) => {
    let actionContent = null;
    if (isLoggedIn) {
      actionContent = (
        <button
          className='justify-content-center'
          style={{ width: '80%' }}
          onClick={() => {
            createConversation({ patient_partner_id: partner.id }, (conversation) => {
              history.push(`/member/conversations/${conversation.uuid}`);
            });
          }}
        >
          Send a message
        </button>
      );
    } else {
      actionContent = (
        <button style={{ width: '80%' }} onClick={() => setSelectedPartnerForModal(partner)}>
          Send a message
        </button>
      );
    }

    return actionContent;
  };

  return (
    <div className='partner-gallery light-nav'>
      <div style={isMobile ? { paddingBottom: '150px' } : null}>
        <HeaderLeftTextRight
          headline={'Meet our PatientPartner Mentors'}
          para={
            isLoggedIn
              ? ''
              : "Answer some questions about yourself and we'll help you find a recovered patient to help you throughout your journey."
          }
          actionContent={
            isLoggedIn ? (
              ''
            ) : (
              <Link to='/member/mentor-match'>
                <button className='marg-bottom-40'>Find a mentor for me</button>
              </Link>
            )
          }
        />
      </div>
      {isMobile && showFilters && <div onClick={() => setShowFilters(false)} className='mobile-filter-bg'></div>}
      <div
        style={isMobile ? { paddingTop: '100px' } : { paddingBottom: '175px' }}
        className={`container ${isMobile ? 'mobile-filter-wrapper' : ''}`}
      >
        <div className={`${isMobile ? 'mobile' : ''} ${showFilters ? 'show' : ''} filter-tools marg-top-40 row`}>
          <div className='col-lg-2'>
            <p className={`bold filter-title ${isMobile ? 'marg-top-10' : ''}`}>Treatment</p>
            <DropdownInput
              values={chosenProcedures}
              options={filterableTreatments}
              setValues={setChosenProcedures}
              marginTop='6px'
              elemClassname='partner-dropdown'
              type='multi'
            />
          </div>

          <div className='col-lg-2'>
            <p className='bold filter-title'>Age Range</p>
            <DropdownInput
              values={chosenAges}
              options={filterableAges}
              setValues={setChosenAges}
              marginTop='6px'
              elemClassname='partner-dropdown'
            />
          </div>

          <div className='col-lg-2'>
            <p className='bold filter-title'>Gender</p>
            <DropdownInput
              values={chosenGender}
              options={['Male', 'Female', 'Non-binary'].map((g) => {
                return { value: g };
              })}
              marginTop='6px'
              elemClassname='partner-dropdown'
              setValues={setChosenGender}
            />
          </div>
          <div className='col-lg-2 marg-top-30 clear-filters-button'>
            <button onClick={() => clearFilters()} className='liner w-100' style={{ padding: '7px', marginTop: '3px' }}>
              Clear all filters
            </button>
          </div>
        </div>
      </div>
      {isMobile && makeSticky && (
        <div className='container filter-wrapper'>
          <div className='row'>
            <div className='col text-center'>
              <IconButtonSvg
                icon={
                  showFilters === true ? (
                    <></>
                  ) : (
                    <svg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5V0.5ZM18 3.5C18.8284 3.5 19.5 2.82843 19.5 2C19.5 1.17157 18.8284 0.5 18 0.5V3.5ZM2 6.5C1.17157 6.5 0.5 7.17157 0.5 8C0.5 8.82843 1.17157 9.5 2 9.5V6.5ZM18 9.5C18.8284 9.5 19.5 8.82843 19.5 8C19.5 7.17157 18.8284 6.5 18 6.5V9.5ZM2 12.5C1.17157 12.5 0.5 13.1716 0.5 14C0.5 14.8284 1.17157 15.5 2 15.5V12.5ZM18 15.5C18.8284 15.5 19.5 14.8284 19.5 14C19.5 13.1716 18.8284 12.5 18 12.5V15.5ZM2 3.5H18V0.5H2V3.5ZM2 9.5H18V6.5H2V9.5ZM2 15.5H18V12.5H2V15.5Z'
                        fill='#fff'
                      />
                    </svg>
                  )
                }
                text={`${showFilters === true ? 'Show Partners' : 'Filters'}`}
                onClick={() => {
                  setShowFilters(!showFilters);
                  ScrollTo('.gallery-sec', 100);
                }}
                classNames={`${showFilters === true ? 'active' : ''} filter-toggle-button marg-top-20`}
                other={
                  chosenProcedures.length + chosenAges.length + chosenGender.length > 0 && (
                    <span className={`filter-count ${showFilters === true ? '' : 'active'}`}>
                      <p>{chosenProcedures.length + chosenAges.length + chosenGender.length}</p>
                    </span>
                  )
                }
              />
            </div>
          </div>
        </div>
      )}
      <div className='container gallery-sec'>
        {isLoading && (
          <div className='marg-bottom-100'>
            <LoadingScreen />
          </div>
        )}
        {!isLoading && (
          <>
            {partnersForGalleryToShowInRows.map((row, rowIndex) => {
              return (
                <div className='container' key={rowIndex}>
                  <div className='row h-100'>
                    {row.map((partner, partnerIndex) => {
                      const actionContent = generateActionContent(partner);
                      return (
                        <div
                          key={partnerIndex}
                          style={{ paddingBottom: '150px' }}
                          className='col-sm-4 ppcol align-items-center marg-bottom-10'
                        >
                          <PatientPartnerColumnForGallery
                            index={partnerIndex}
                            partner={partner}
                            actionContent={actionContent}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}

            <div className='row h-100 marg-bottom-100'>
              {patientPartners.length == 0 && (
                <div className='marg-top-40 marg-center '>
                  <h6 className='marg-bottom-20 text-center'>No results found for those filters</h6>
                </div>
              )}
            </div>
            {pagination && pagination.total_pages > 1 && (
              <Pagination pagination={pagination} onPageChange={handlePageChange} />
            )}
          </>
        )}
      </div>
      {!isLoggedIn && (
        <CustomCtaFooter
          headline='Looking for the most relatable PatientPartner&trade;?'
          para="Take a short questionnaire and we'll provide you with the most relatable PatientPartner™ recommendations"
          buttontxt='Get Started'
          link='/member/join/pre-signup'
        />
      )}
      {selectedPartnerForModal && (
        <PartnersGalleryModal
          patientPartner={selectedPartnerForModal}
          onClose={() => setSelectedPartnerForModal(null)}
        />
      )}
    </div>
  );
}
